module.exports = __webpack_public_path__ + "static/media/Divina 50x150 - Dark Grey Geometric II.95b495fe.jpg";